import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import {SingleSource,WorkItems} from '../utility';
import WorkFooter from '../components/workfooter';
import Context from '../components/context';

export default function WorkPage() {
    const workItem = WorkItems();

    return (
        <div className='work-fontColor2'>
            <Container className='pt-5 mt-5 work'>
                <div className='subTitle text-start'>Public Sector Service Platform</div>
                <h1 className='mainTitle2 text-start py-3'>{workItem.title}</h1>
                <div className='mainDes text-start pb-3'>
                    Small Business Development Centers (SBDC) is the largest service organization under the U.S. Small Business Administration, offering business counseling and training to entrepreneurs.
                    &nbsp;<span className='workBold'>The goal was to increase client conversion through the redesign the New York SBDC website.</span>
                </div>
                <div className='text-start pb-3'>
                    Check product at <a href='https://nysbdc.org/'>https://nysbdc.org/</a>.
                </div>
                <Row className='py-5 text-start'>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Client
                        </div>
                        <div>
                            SBA
                        </div>
                    </Col>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Role
                        </div>
                        <div>
                            Lead UX Desinger
                        </div>
                    </Col>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Time
                        </div>
                        <div>
                            08.2023 - 12.2023
                        </div>
                    </Col>
                    <Col lg sm='12' className='py-3'>
                        <div className='workBold2'>
                            Team
                        </div>
                        <div>
                            An agile team of 13 
                        </div>
                    </Col>
                </Row>
                <Row className='pb-5'>
                    <Col lg='9' xs='12'>
                        <video width="100%" height="600px" autoPlay muted playsInline style={{ borderRadius: '15px',border: '2px solid #ccc' }}>
                            <source src={`/img/${workItem.assets.toLocaleLowerCase()}/1.mp4`} type="video/mp4" />
                        </video>
                    </Col>
                    <Col lg='3' xs='12'>
                        <video width="100%" height="600px" autoPlay muted playsInline style={{ borderRadius: '15px',border: '2px solid #ccc' }}>
                            <source src={`/img/${workItem.assets.toLocaleLowerCase()}/2.mov`} type="video/mp4" />
                        </video>
                    </Col>
                </Row>
            </Container>
            <section id="section-2">
                <Container>
                    <Container className='work'>
                        <div className='text-start'>
                            The restructured and rebranded site leads to:
                        </div>
                        <Row className='py-5'>
                            <Col>
                                <div className='mainTitle'>
                                    29%
                                </div>
                                <div className='mt-3'>
                                    Growth in Booking
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    43%
                                </div>
                                <div className='mt-3'>
                                    More Subscribers
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    50%
                                </div>
                                <div className='mt-3'>
                                    Increased Mobile Traffic
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg3'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start'>
                        <div className='workBold3 py-5' id="problem_statement">
                            Problem Statement
                        </div>
                        <div className='mb-3'>
                            The SBDC website was outdated and 
                            <span className='workBold'> content-heavy</span>, with
                            <span className='workBold'> poor mobile support</span> - making it especially difficult for time-strapped small business owners to use.
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <Row>
                        <Col lg sm='12' className='text-start py-5 mb-5'>
                            <div className='workBoldItalic pt-5' id="research">
                                Discovery Research
                            </div>
                            <div className='workBold3 pb-5'>
                                A Disorganized Site Leads to User Frustration and Lost Bookings
                            </div>
                            <div className='pb-3 mb-3'>
                                <div className='pb-3 mb-3'>
                                    To align the redesign with real user needs, I conducted:
                                </div>
                                <ul>
                                    <li>
                                        <span className='workBold'>Stakeholder interviews </span>with regional directors and the state communications team
                                    </li>
                                    <li>
                                        <span className='workBold'>User interviews </span>and 
                                        <span className='workBold'> navigation testing </span>with current and prospective clients
                                    </li>
                                    <li>
                                        <span className='workBold'>Competitive analysis </span>of other public-facing support organizations
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <div className='pb-3 mb-3'>
                                    Research revealed key pain points and opportunities, such as
                                </div>
                                <ul>
                                    <li>
                                        Clearer entry points based on goals
                                    </li>
                                    <li>
                                        Mobile-friendly layout for on-the-go users
                                    </li>
                                    <li>
                                        Streamlined appointment booking process
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg='12' md='12' sm='12' className='text-start pb-5'>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/affinity.png`} />                         
                        </Col>
                    </Row>
                    <Row>
                        <Col lg='12' md='12' sm='12' className='text-start pb-5'>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/matrix.png`} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container fluid>
                    <Row className='mx-0 py-5 my-5'>
                        <Col className='px-0'>
                            <div className='banner leftbanner'>

                            </div>
                        </Col>
                        <Col lg='10' md='10' sm='10' xs='10' className='px-0'>
                            <Container className='work'>
                                <Row>
                                    <Col lg='12' md='12' sm='12' xs='12' className='text-start py-5' id="personas">
                                        <div className='workItalic pt-5'>
                                            Personas
                                        </div>
                                        <div className='workBold py-2 my-2'>
                                            <span className='workBold3'>Experienced & New Business Owner</span>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg='10' md='10' sm='10' xs='12' className='text-start pb-5 roundImg'>
                                        <SingleSource src={`/img/${workItem.assets.toLocaleLowerCase()}/personaanna.png`} />
                                    </Col>
                                    <Col lg='2' md='2' sm='2' xs='0'></Col>
                                </Row>
                                <Row>
                                    <Col lg='2' md='2' sm='2' xs='0'></Col>
                                    <Col lg='10' md='10' sm='10' xs='12' className='text-start pb-5 align-self-end roundImg'>
                                        <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/personaandrew.png`} />
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col className='align-self-end px-0'>
                            <div className='banner rightbanner float-end'>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start py-5 my-5'>
                        <div className='workItalic pt-5' id="strategy">
                            Design Strategy
                        </div>
                        <div className='workBold3 pb-5'>
                            Information Architecture Centered Around User Goals
                        </div>
                        <div className='pb-5'>
                            I restructured the content into a new information architecture aligned with the small business lifecycle:
                        </div>
                        <div className='pb-5'>
                            •	Start a Business
                            <br></br>
                            •	Manage & Grow
                            <br></br>
                            •	Get Funding
                            <br></br>
                            •	Specialized Support (e.g., MWBEs, Veterans, Exporters)
                        </div>
                        <div>
                            Each landing page combined educational content, relevant tools, and links to local support—helping users self-navigate without needing to understand agency structure.
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start py-5 my-5'>
                        <div className='workItalic pt-5'>
                            Design Execution
                        </div>
                        <div className='workBold3 pb-5'>
                            Modular, Responsive UI System
                        </div>
                        <div className='pb-5'>
                            Using Figma, we designed a mobile-first layout that aligns with U.S. Web Design System (USWDS) :
                        </div>
                        <div>
                            •	Clear visual hierarchy to guide users toward primary CTAs
                            <br></br>
                            •	A flexible grid system that adapts to varying content lengths
                            <br></br>
                            •	Accessible typography and contrast ratios for WCAG 2.1 AA compliance
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg3'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work py-5'>
                    <Row>
                        <Col lg='12' md='12' sm='12' className='text-start pt-5' id="enhancements">
                            <div className='workBoldItalic pb-2 mb-2'>
                                Enhancement 1
                            </div>
                            <div className='workBold3 pb-2 mb-2'>
                                Rethinking Appointment Booking
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid className='work' id='pain_points'>
                    <Row className='mx-0'>
                        <Col className='leftBannerWideContainerFill'>
                        
                        </Col>
                        <Col lg='8' className='leftBannerWide'>
                            <Container>
                                <Row>
                                    <Col className='text-start py-3'>
                                        <div>
                                            The major <span className='workBold3'>pain points</span> discovered from user interviews are:
                                            <br></br>
                                            <br></br>
                                            1.	High abandonment caused by lengthy intake forms
                                            <br></br>
                                            2.	Long wait times and excessive back-and-forth communication
                                            <br></br>
                                            3.	Poor matching with suitable advisors
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                </Container>
                <Container className='work'>
                    <div className='text-start py-5'>
                        <div className='pb-5'>
                            A major opportunity was streamlining appointment booking with SBDC advisors. I designed a selectable advisor system that let users:
                        </div>
                        <div className='pb-5'>
                            •	Filtering by location
                            <br></br>
                            •	Viewing advisor bios
                            <br></br>
                            •	Choosing a specific advisor and availability
                        </div>
                        <div className='pb-3'>
                            This gave users more control while reducing administrative overhead, aligning with modern scheduling expectations.
                        </div>
                    </div>
                </Container>
                <Container fluid className='work'>
                    <Row className='mx-0'>
                        <Col></Col>
                        <Col lg='10' className='workBold text-start pt-5 pb-2'>
                            Appointment booking user flow versions
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row className='mx-0'>
                        <Col></Col>
                        <Col lg='10' id='user_flow'>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/userflow1.png`} />
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row className='mx-0'>
                        <Col></Col>
                        <Col lg='10' className='pt-3'>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/userflow2.png`} />
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row className='mx-0'>
                        <Col></Col>
                        <Col lg='10' className='pt-3'>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/userflow3.png`} />
                        </Col>
                        <Col></Col>
                    </Row>
                    <Container className='work'>
                        <Row>
                            <Col className='text-start py-5 my-5'>
                                <div>
                                    <span className='workBold'>Adjusting to Constraints</span>
                                    <br></br>
                                    During a dev sync, we learned not all centers could support real-time advisor scheduling. I proposed a location-based approach that preserved a smooth user experience while laying groundwork for future advisor-level booking.
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <section>
                <Container fluid className='work' id='solutions'>
                    <Row className='mx-0'>
                        <Col>
                        
                        </Col>
                        <Col lg='8' className='rightBannerWide'>
                            <Container>
                                <Row>
                                    <Col className='text-start py-3'>
                                        <div>
                                            The Compromise: <span className='workBold3'>Location-Based Booking.</span>
                                            <br></br>
                                            <br></br>
                                            •	Users select a location
                                            <br></br>
                                            •	Fill out a short intake form
                                            <br></br>
                                            •	Centers internally assign an advisor based on expertise and availability
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col className='rightBannerWideContainerFill'>
                        </Col>
                    </Row>
                </Container>
                <Container className='work'>
                    <Row className='mx-0'>
                        <Col lg='10' className='workBold text-start pt-5 mt-5 pb-2'>
                            Appointment booking UI versions
                        </Col>
                    </Row>
                    <Row className='mx-0'>
                        <Col>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/homepage_left.jpg`} />
                        </Col>
                        <Col>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/11-1.jpg`} />
                            <br></br>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/11-2.jpg`} />
                            <br></br>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/11-3.jpg`} />
                            <br></br>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/11-4.jpg`} />
                        </Col>
                        <Col>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/12-1.jpg`} />
                            <br></br>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/12-2.jpg`} />
                            <br></br>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/12-3.jpg`} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='work pt-5'>
                    <Row>
                        <Col lg='12' md='12' sm='12' className='text-start py-5 mt-5' id="improve_1">
                            <div className='workBoldItalic pb-2 mb-2'>
                                Enhancement 2
                            </div>
                            <div className='workBold3 pb-2 mb-2'>
                                Facelifting the homepage
                            </div>
                            <div>
                                I redesigned the homepage to build trust, professionalism, and clarity for new users.
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid className='work' id='pain_points'>
                    <Row className='mx-0'>
                        <Col className='leftBannerWideContainerFill'>
                        
                        </Col>
                        <Col lg='8' className='leftBannerWide'>
                            <Container>
                                <Row>
                                    <Col className='text-start py-4'>
                                        <div>
                                            <span className='workBold3'>Before</span>:
                                            <br></br>
                                            <br></br>
                                            •	Non-responsive layout
                                            <br></br>
                                            •	Crowded and text-heavy
                                            <br></br>
                                            •	No visual hierarchy or clear next step
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                </Container>
                <br></br>
                <br></br>
                <Container fluid className='work' id='solutions'>
                    <Row className='mx-0'>
                        <Col>
                        
                        </Col>
                        <Col lg='8' className='rightBannerWide'>
                            <Container>
                                <Row>
                                    <Col className='text-start py-3'>
                                        <div>
                                            <span className='workBold3'>After</span>:
                                            <br></br>
                                            <br></br>
                                            •	Clear CTAs
                                            <br></br>
                                            •	Modular, mobile-first layout
                                            <br></br>
                                            •	Regional locator and services menu upfront
                                            <br></br>
                                            •	Distinct content sections (services, news, stories)
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col className='rightBannerWideContainerFill'>
                        </Col>
                    </Row>
                </Container>
                <section>
                    <Container className='work py-5'>
                        <Row>
                            <Col lg='12' md='12' sm='12' className='text-start py-5' id="improve_1">
                                <div className='workBoldItalic pb-2 mb-2'>
                                    Final Design
                                </div>
                                <div className='workBold3 pb-2 mb-2'>
                                    Navigating a Statewide Rebrand
                                </div>
                                <div>
                                    Shortly after handoff, New York introduced new branding and accessibility mandates. I adapted the design to preserve core UX while aligning with NY.gov standards. The final site reflects a balance of:
                                    <br></br>
                                    <br></br>
                                    •	State branding and governance
                                    <br></br>
                                    •	Original user-centered architecture
                                    <br></br>
                                    •	Operational constraints across regional centers
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <Container className='work'>
                    <Row className='mx-0'>
                        <Col lg='10' className='text-start pt-5 pb-2'>
                            Homepage UI versions
                        </Col>
                    </Row>
                    <Row className='mx-0'>
                        <Col>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/homepage.jpg`} />
                        </Col>
                        <Col>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/homepage_v2.jpg`} />
                        </Col>
                        <Col>
                            <SingleSource className='float-end' src={`/img/${workItem.assets.toLocaleLowerCase()}/homepage_v3.jpg`} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container className='py-5 my-5 work'>
                    <div className='breaker altbg3'>

                    </div>
                </Container>
            </section>
            <section>
                    <Container className='work pb-5'>
                        <Row>
                            <Col lg='12' md='12' sm='12' className='text-start py-5' id="impacts">
                                <div className='workBoldItalic pb-2 mb-2'>
                                    Impacts
                                </div>
                                <div className='workBold3 pb-2 mb-2'>
                                    Increased Engagement and Accessibility
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                    •	29% growth in bookings in 3 months
                                    <br></br>
                                    •	43% increase in newsletter sign-ups
                                    <br></br>
                                    •	50%+ of traffic now from mobile with higher task completion
                                    <br></br>
                                    •	Internal recognition for accessibility and branding consistency
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            <section>
                <Container fluid className='work altbg3 py-5' id='validation'>
                    <Container className='work' id='conclusion'>
                        <Row className='mx-0'>
                            <Col className='py-5 text-start altbg3Font'>
                                <span className='workItalic'>Takeaways</span>
                                <div className='workBold3 pb-2 mb-2'>
                                    Designing for Impact Within Real-World Constraints
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                    <span className='workBold'>
                                        Design with intent, adapt with impact
                                    </span>
                                </div>
                                <div>
                                    Real-world projects often bring shifting requirements; designing with flexibility ensures solutions remain effective.
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                    <span className='workBold'>
                                        Core UX stayed intact despite shifting guidelines
                                    </span>
                                </div>
                                <div>
                                   Even with new state branding and technical constraints, the user-centered structure and flows held strong. 
                                </div>
                                <br></br>
                                <br></br>
                                <div>
                                    <span className='workBold'>
                                        Good design evolves under limitations
                                    </span>
                                </div>
                                <div>
                                    Strong UX doesn't vanish under constraints; it adapts, endures, and continues to serve users' needs.
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <Container className='work workFooter'>
                <WorkFooter workPrevious={workItem.workPrevious} workPreviousTitle={workItem.workPreviousTitle} workNext={workItem.workNext} workNextTitle={workItem.workNextTitle} />
            </Container>
            <Context workPrevious={workItem.workPrevious} workNext={workItem.workNext} contextItems={workItem.contextItems} />
        </div>
    );
  }